var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1023,
    viewBox: "0 0 1440 1023",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.3929 836.183C-11.6023 836.183 -95.1276 919.724 -95.1276 1022.74C-95.1276 1125.75 -11.6023 1209.3 91.3929 1209.3C194.388 1209.3 277.913 1125.75 277.913 1022.74C277.913 919.724 194.388 836.183 91.3929 836.183ZM91.3929 1115.55C40.1486 1115.55 -1.39686 1073.99 -1.39686 1022.74C-1.39686 971.485 40.1486 929.932 91.3929 929.932C142.637 929.932 184.183 971.485 184.183 1022.74C184.183 1073.99 142.637 1115.55 91.3929 1115.55Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.108 -51.2688C464.108 -51.2688 397.23 -20.8637 409.1 54.3526C422.418 138.69 345.19 174.887 292.425 154.038C239.661 133.116 243.353 55.728 143.035 53.3391C40.5468 50.8777 18.9779 -46.4909 18.9779 -46.4909",
    stroke: "#857EFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.88 -73.9277C386.88 -73.9277 357.928 -9.64275 368.279 54.2803C378.701 118.203 331.872 125.732 313.271 118.203C274.62 102.711 267.165 19.7488 204.775 14.3917C157.873 10.3377 94.7586 42.4078 61.3196 -30.3471",
    stroke: "#857EFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.612 -45.3325C355.612 -45.3325 366.035 20.328 319.929 8.60037C267.093 -4.86474 267.889 -36.4281 201.011 -6.60217C177.198 4.03961 81.3685 7.15252 100.694 -51.3411",
    stroke: "#857EFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.173 95.5443C333.246 95.5443 342.222 82.3205 342.222 66.008C342.222 49.6955 333.246 36.4717 322.173 36.4717C311.1 36.4717 302.124 49.6955 302.124 66.008C302.124 82.3205 311.1 95.5443 322.173 95.5443Z",
    stroke: "#857EFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6689 366.342C26.6689 368.939 24.5714 371.037 21.9744 371.037C19.3774 371.037 17.2799 368.939 17.2799 366.342C17.2799 363.744 19.3774 361.646 21.9744 361.646C24.5714 361.646 26.6689 363.744 26.6689 366.342Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4329 366.342C57.4329 368.939 55.3353 371.037 52.7384 371.037C50.1414 371.037 48.0439 368.939 48.0439 366.342C48.0439 363.744 50.1414 361.646 52.7384 361.646C55.3353 361.646 57.4329 363.744 57.4329 366.342Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1968 366.342C88.1968 368.939 86.0993 371.037 83.5023 371.037C80.9054 371.037 78.8078 368.939 78.8078 366.342C78.8078 363.744 80.9054 361.646 83.5023 361.646C86.0993 361.646 88.1968 363.744 88.1968 366.342Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.961 366.342C118.961 368.939 116.863 371.037 114.266 371.037C111.669 371.037 109.572 368.939 109.572 366.342C109.572 363.744 111.669 361.646 114.266 361.646C116.863 361.646 118.961 363.744 118.961 366.342Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.725 366.342C149.725 368.939 147.627 371.037 145.03 371.037C142.433 371.037 140.336 368.939 140.336 366.342C140.336 363.744 142.433 361.646 145.03 361.646C147.627 361.646 149.725 363.744 149.725 366.342Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.489 366.342C180.489 368.939 178.391 371.037 175.794 371.037C173.197 371.037 171.1 368.939 171.1 366.342C171.1 363.744 173.197 361.646 175.794 361.646C178.391 361.646 180.489 363.744 180.489 366.342Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89214 395.314C9.48484 395.314 11.5866 393.211 11.5866 390.618C11.5866 388.025 9.48484 385.923 6.89214 385.923C4.29944 385.923 2.19763 388.025 2.19763 390.618C2.19763 393.211 4.29944 395.314 6.89214 395.314Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2507 390.618C42.2507 393.216 40.1531 395.314 37.5562 395.314C34.9592 395.314 32.8617 393.216 32.8617 390.618C32.8617 388.021 34.9592 385.923 37.5562 385.923C40.1531 386.023 42.2507 388.121 42.2507 390.618Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0146 390.618C73.0146 393.216 70.9171 395.314 68.3201 395.314C65.7232 395.314 63.6256 393.216 63.6256 390.618C63.6256 388.021 65.7232 385.923 68.3201 385.923C70.9171 386.023 73.0146 388.121 73.0146 390.618Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.779 390.618C103.779 393.216 101.681 395.314 99.084 395.314C96.4871 395.314 94.3895 393.216 94.3895 390.618C94.3895 388.021 96.4871 385.923 99.084 385.923C101.681 386.023 103.779 388.121 103.779 390.618Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.948 395.314C132.541 395.314 134.642 393.211 134.642 390.618C134.642 388.025 132.541 385.923 129.948 385.923C127.355 385.923 125.253 388.025 125.253 390.618C125.253 393.211 127.355 395.314 129.948 395.314Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.712 395.314C163.304 395.314 165.406 393.211 165.406 390.618C165.406 388.025 163.304 385.923 160.712 385.923C158.119 385.923 156.017 388.025 156.017 390.618C156.017 393.211 158.119 395.314 160.712 395.314Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.07 390.618C196.07 393.216 193.973 395.314 191.376 395.314C188.779 395.314 186.681 393.216 186.681 390.618C186.681 388.021 188.779 385.923 191.376 385.923C194.073 386.023 196.07 388.121 196.07 390.618Z",
    fill: "#857EFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1180.29 785.555C1180.29 788.152 1178.19 790.25 1175.59 790.25C1173.1 790.15 1171 788.052 1171 785.555C1171 782.957 1173.1 780.859 1175.69 780.859C1178.19 780.859 1180.29 782.957 1180.29 785.555Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.05 785.555C1211.05 788.152 1208.96 790.25 1206.36 790.25C1203.76 790.25 1201.66 788.152 1201.66 785.555C1201.66 782.957 1203.76 780.859 1206.36 780.859C1208.96 780.859 1211.05 782.957 1211.05 785.555Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.82 785.555C1241.82 788.152 1239.72 790.25 1237.12 790.25C1234.53 790.25 1232.43 788.152 1232.43 785.555C1232.43 782.957 1234.53 780.859 1237.12 780.859C1239.72 780.859 1241.82 782.957 1241.82 785.555Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.58 785.555C1272.58 788.152 1270.48 790.25 1267.89 790.25C1265.29 790.25 1263.19 788.152 1263.19 785.555C1263.19 782.957 1265.29 780.859 1267.89 780.859C1270.48 780.859 1272.58 782.957 1272.58 785.555Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.34 785.555C1303.34 788.152 1301.25 790.25 1298.65 790.25C1296.05 790.25 1293.96 788.152 1293.96 785.555C1293.96 782.957 1296.05 780.859 1298.65 780.859C1301.25 780.859 1303.34 782.957 1303.34 785.555Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.11 785.555C1334.11 788.152 1332.01 790.25 1329.41 790.25C1326.82 790.25 1324.72 788.152 1324.72 785.555C1324.72 782.957 1326.82 780.859 1329.41 780.859C1332.01 780.859 1334.11 782.957 1334.11 785.555Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.87 785.555C1364.87 788.152 1362.78 790.25 1360.18 790.25C1357.58 790.25 1355.48 788.152 1355.48 785.555C1355.48 782.957 1357.58 780.859 1360.18 780.859C1362.78 780.859 1364.87 782.957 1364.87 785.555Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.64 785.555C1395.64 788.152 1393.54 790.25 1390.94 790.25C1388.35 790.25 1386.25 788.152 1386.25 785.555C1386.25 782.957 1388.35 780.859 1390.94 780.859C1393.54 780.859 1395.64 782.957 1395.64 785.555Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.4 785.555C1426.4 788.152 1424.3 790.25 1421.71 790.25C1419.11 790.25 1417.01 788.152 1417.01 785.555C1417.01 782.957 1419.11 780.859 1421.71 780.859C1424.3 780.859 1426.4 782.957 1426.4 785.555Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.87 809.831C1195.87 812.429 1193.77 814.527 1191.18 814.527C1188.58 814.527 1186.48 812.429 1186.48 809.831C1186.48 807.234 1188.58 805.136 1191.18 805.136C1193.77 805.236 1195.87 807.334 1195.87 809.831Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.04 814.527C1224.63 814.527 1226.73 812.424 1226.73 809.831C1226.73 807.238 1224.63 805.136 1222.04 805.136C1219.45 805.136 1217.35 807.238 1217.35 809.831C1217.35 812.424 1219.45 814.527 1222.04 814.527Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.8 814.527C1255.4 814.527 1257.5 812.424 1257.5 809.831C1257.5 807.238 1255.4 805.136 1252.8 805.136C1250.21 805.136 1248.11 807.238 1248.11 809.831C1248.11 812.424 1250.21 814.527 1252.8 814.527Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.16 809.831C1288.16 812.429 1286.07 814.527 1283.47 814.527C1280.87 814.527 1278.77 812.429 1278.77 809.831C1278.77 807.234 1280.87 805.136 1283.47 805.136C1286.07 805.236 1288.16 807.334 1288.16 809.831Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.93 809.831C1318.93 812.429 1316.83 814.527 1314.23 814.527C1311.64 814.527 1309.54 812.429 1309.54 809.831C1309.54 807.234 1311.64 805.136 1314.23 805.136C1316.83 805.236 1318.93 807.334 1318.93 809.831Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349.69 809.831C1349.69 812.429 1347.59 814.527 1345 814.527C1342.4 814.527 1340.3 812.429 1340.3 809.831C1340.3 807.234 1342.4 805.136 1345 805.136C1347.59 805.236 1349.69 807.334 1349.69 809.831Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.86 814.527C1378.45 814.527 1380.55 812.424 1380.55 809.831C1380.55 807.238 1378.45 805.136 1375.86 805.136C1373.27 805.136 1371.17 807.238 1371.17 809.831C1371.17 812.424 1373.27 814.527 1375.86 814.527Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406.62 814.527C1409.22 814.527 1411.32 812.424 1411.32 809.831C1411.32 807.238 1409.22 805.136 1406.62 805.136C1404.03 805.136 1401.93 807.238 1401.93 809.831C1401.93 812.424 1404.03 814.527 1406.62 814.527Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.98 809.831C1441.98 812.429 1439.88 814.527 1437.29 814.527C1434.69 814.527 1432.59 812.429 1432.59 809.831C1432.59 807.234 1434.69 805.136 1437.29 805.136C1439.98 805.236 1441.98 807.334 1441.98 809.831Z",
    fill: "#857EFF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1550.55 1104.54H1549.47V757.867C1549.47 691.717 1495.71 637.953 1429.56 637.953C1363.42 637.953 1309.93 691.853 1309.93 757.867V1104.54H1308.84V757.867C1308.84 691.172 1363.01 637 1429.7 637C1496.39 637 1550.55 691.172 1550.55 757.867V1104.54Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1533 1104.54H1532.05V757.867C1532.05 701.517 1486.18 655.511 1429.7 655.511C1373.35 655.511 1327.35 701.381 1327.35 757.867V1104.54H1326.26V757.867C1326.4 700.972 1372.81 654.558 1429.7 654.558C1486.72 654.558 1533 700.972 1533 757.867V1104.54Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515.44 1104.54H1514.35V757.867C1514.35 711.181 1476.38 673.069 1429.56 673.069C1382.74 673.069 1345.04 711.181 1345.04 757.867V1104.54H1343.95V757.867C1343.95 710.5 1382.47 672.117 1429.7 672.117C1477.06 672.117 1515.44 710.636 1515.44 757.867V1104.54Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497.88 1104.54H1496.79V757.867C1496.79 720.845 1466.72 690.628 1429.56 690.628C1392.54 690.628 1362.33 720.708 1362.33 757.867V1104.54H1361.24V757.867C1361.24 720.3 1391.86 689.675 1429.42 689.675C1466.99 689.675 1497.61 720.3 1497.61 757.867V1104.54H1497.88Z",
    fill: "#857EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.46 1104.54H1479.37V757.867C1479.37 730.509 1457.05 708.186 1429.7 708.186C1402.34 708.186 1380.02 730.509 1380.02 757.867V1104.54H1378.93V757.867C1378.93 729.964 1401.66 707.234 1429.56 707.234C1457.46 707.234 1480.19 729.964 1480.19 757.867V1104.54H1480.46Z",
    fill: "#857EFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1387.21 -287C1248.98 -287 1137 -174.939 1137 -36.7446C1137 101.449 1249.04 213.511 1387.21 213.511C1525.37 213.511 1637.41 101.449 1637.41 -36.7446C1637.41 -174.939 1525.37 -287 1387.21 -287ZM1387.21 134.662C1292.61 134.662 1215.9 57.9379 1215.9 -36.6803C1215.9 -131.298 1292.61 -208.023 1387.21 -208.023C1481.81 -208.023 1558.52 -131.298 1558.52 -36.6803C1558.52 57.9379 1481.81 134.662 1387.21 134.662Z",
    fill: "#857EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1023,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 270.982,
    height: 33.6671,
    fill: "white",
    transform: "translate(-74.912 361.646)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 270.982,
    height: 33.6671,
    fill: "white",
    transform: "translate(1171 780.859)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241.717,
    height: 467.543,
    fill: "white",
    transform: "translate(1308.84 637)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login_background.4599eb75331ec90d008e755e744bd8c1.svg";
export { ForwardRef as ReactComponent };